import React, { useEffect, useState } from 'react';
import images from '../../../../assets/images';
import Tooltip from 'devextreme-react/tooltip';
import Button from 'devextreme-react/button';
import { useTranslation } from 'react-i18next';
import VesselFilterControl from '../live-tracking-vessel-filter/VesselFilterControl';
import { Fleet } from '../../../../types/fleet';

export default function VesselFilterIcon({
  fleetList,
  onFleetSelectionChange,
  searchedVessels,
  onVesselSelectionChange,
}: {
  fleetList: Fleet[];
  onFleetSelectionChange?: (selectedFleetIds: number[]) => void;
  searchedVessels: any[];
  onVesselSelectionChange?: (selectedVesselImos: string[]) => void;
}) {
  const { t } = useTranslation();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedFleetIds, setSelectedFleetIds] = useState<number[]>(
    fleetList.map((fleet) => fleet.fleetId)
  );
  const handleClick = () => {
    setIsFilterVisible(true);
  };
  const localOnFleetSelectionChange = (newIds: number[]) => {
    setSelectedFleetIds(newIds);
    if (onFleetSelectionChange) onFleetSelectionChange(newIds);
  };

  useEffect(() => {
    if (selectedFleetIds.length === 0) {
      setSelectedFleetIds(fleetList.map((fleet) => fleet.fleetId));
    }
  }, [fleetList]);

  return (
    <div className="vessel-filter-control-wrapper">
      <Button
        id="vesselFilter"
        className="vessel-filter-button"
        onClick={handleClick}
      >
        <img src={images.vesselFilterIcon} alt="Vessel Filter" />
        <Tooltip
          target={'#vesselFilter'}
          showEvent="dxhoverstart"
          hideEvent="dxhoverend"
          position="left"
          contentRender={() => {
            return (
              <div className="m-l-tooltip-wrapper">
                {t('tooltips.vesselFilter')}
              </div>
            );
          }}
        />
      </Button>
      {isFilterVisible && (
        <VesselFilterControl
          onClose={setIsFilterVisible}
          target={'#vesselFilter'}
          visible={isFilterVisible}
          fleetList={fleetList}
          onFleetSelectionChange={localOnFleetSelectionChange}
          searchedVessels={searchedVessels}
          onVesselSelectionChange={onVesselSelectionChange}
          selectedFleetIds={selectedFleetIds}
        />
      )}
    </div>
  );
}
